import { render, staticRenderFns } from "./SidebarForm.vue?vue&type=template&id=11b84cb1&"
import script from "./SidebarForm.vue?vue&type=script&lang=js&"
export * from "./SidebarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports